import styled from 'styled-components';

export default styled.div`
  width: 100%;
  height: 100%;
  opacity: ${({ inTransition }) => (inTransition ? 0 : 1)};
  transition: opacity 400ms;
  pointer-events: ${({ inTransition }) => (inTransition ? 'none' : 'all')};
`;
